import { z } from "zod";
import { FACTION_IDS } from "./factions.js";
import { SECTOR_IDS } from "./world-layout.js";
import { stationIdSchema, type StationDefinition } from "./stations.js";

export const stationTruceTermsSchema = z
  .strictObject({
    format: z.literal(1),
    policyVersion: z.literal("station-truce-v1"),
    trigger: z.literal("pvp-murder"),
    selfDefense: z.literal("until-either-sector-exit"),
    completion: z.literal("offender-death-or-sector-exit"),
    participation: z.literal("positive-damage-or-defender-healing"),
    guardRewards: z.literal("none"),
    credits: z.literal("100"),
    components: z.literal(3),
    seasonXp: z.literal(0),
    station: z
      .strictObject({
        id: stationIdSchema,
        name: z.string().min(1).max(100),
        factionId: z.enum(FACTION_IDS).nullable(),
        sectorId: z.enum(SECTOR_IDS),
        x: z.number().finite().nonnegative(),
        y: z.number().finite().nonnegative(),
        radius: z.number().finite().positive(),
      })
      .readonly(),
  })
  .readonly();
export type StationTruceTerms = z.infer<typeof stationTruceTermsSchema>;

/** Captured once at the crime; later station/catalog changes cannot alter the hunt. */
export function captureStationTruceTerms(
  station: StationDefinition,
): StationTruceTerms {
  return stationTruceTermsSchema.parse({
    format: 1,
    policyVersion: "station-truce-v1",
    trigger: "pvp-murder",
    selfDefense: "until-either-sector-exit",
    completion: "offender-death-or-sector-exit",
    participation: "positive-damage-or-defender-healing",
    guardRewards: "none",
    credits: "100",
    components: 3,
    seasonXp: 0,
    station: { ...station },
  });
}

export function eligibleTruceDefender(contribution: {
  damage: number;
  healing: number;
}): boolean {
  return contribution.damage > 0 || contribution.healing > 0;
}
